<script>
import { mapGetters } from 'vuex'
import Tabs from '@/components/MarketplaceComponents/Tabs.vue'
import Breadcrumbs from '@/components/MarketplaceComponents/Breadcrumbs.vue'
import PageTitle from '@/components/MarketplaceComponents/PageTitle.vue'
import SubscriptionCard from '@/components/Subscription/SubscriptionCard'
import StoreService from '@/services/StoreService'

export default {
  components: {
    SubscriptionCard,
    Tabs,
    Breadcrumbs,
    PageTitle
  },

  async asyncData ({ $axios }) {
    let subscriptionProducts = []

    try {
      const { data } = await StoreService.getProducts($axios)
      subscriptionProducts = data.data.filter(s => !s.is_hidden).filter(s => s.type === 'subscription_freeroll')
    } catch (e) {
      console.log(e)
    }

    return {
      subscriptionProducts
    }
  },

  data () {
    return {
      subscriptionProducts: []
    }
  },

  computed: {
    ...mapGetters('user', ['isAuthorized']),

    breadcrumbs () {
      return [
        { title: this.$t('buySubscription') }
      ]
    },

    tabs () {
      return [
        {
          id: 'game',
          title: this.$t('servicesInGame')
        },
        {
          id: 'app',
          title: this.$t('applications')
        },
        {
          id: 'social',
          title: this.$t('socialNetworks')
        },
        {
          id: 'software',
          title: this.$t('software')
        },
        {
          id: 'offerwall',
          title: this.$t('offerwalls')
        },
        {
          id: 'others',
          title: this.$t('others')
        },
        {
          id: 'subscription',
          title: this.$t('subscriptions')
        }
      ]
    }
  },

  methods: {
    setActiveTab (tabId) {
      if (tabId !== 'subscription' && this.tabs?.map(tab => tab.id).includes(tabId)) {
        this.$router.push(`/?tab=${tabId}`)

        this.$gtag.event(`${tabId}_marketplace_click`, { account_id: this.user?.id })
      }
    }
  }
}
</script>

<template>
  <div :class="$style.page">
    <Tabs :tabs="tabs" active-tab-id="subscription" @setActiveTab="setActiveTab" />

    <Breadcrumbs :list="breadcrumbs" />

    <div :class="$style.page__body">
      <PageTitle with-go-back :title="$t('buySubscription')" />

      <div :class="$style.subscriptions">
        <SubscriptionCard :class="$style.subscription" :subscription-products="subscriptionProducts" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.page {
  width: 100%;

  &__body {
    padding: 16px;
  }
}

.subscriptions {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 12px;

  @media(min-width: $breakpointDesktop) {
    grid-template-columns: 1fr 1fr;
  }
}

.subscription {
  width: 100%;
}
</style>
